export const PATH_LOGIN = "/login";
export const PATH_SIGNUP = "/sign-up";

export const PATH_HOME = "/";
export const PATH_CLIENT_INFO = "/client-information";
export const PATH_CLIENT_CREATE = "/client-create";
export const PATH_COUPON_MANAGEMENT = "/coupon-management";
export const PATH_COUPON_REDEEM = "/coupon-redeem";
export const PATH_COUPON_LIST = "/coupons";
export const PATH_COUPON_FAMILY = "/coupon-family";
export const PATH_CREATE_COUPON_FAMILY = "/create-coupon-family";
export const PATH_GENERATE_COUPON = "/generate-coupon";
export const PATH_GENERATE_CDIC_COUPON = "/generate-cdic-coupon";
export const PATH_CDIC_COUPON_LIST = "/cdic-coupons";
export const PATH_CDIC_CLIENT_INFO = "/cdic-client-information";
export const PATH_CREATE_CDIC_CLIENT = "/create-cdic-client";
export const PATH_CDIC_COUPON_REDEEM = "/cdic-coupon-redeem";

export const PATH_CLINIC = "/clinic";
export const PATH_ADD_CLINIC = "/add-clinic";

export const PATH_ADMINS = "/admins";
export const PATH_ADD_ADMIN = "/add-admin";

export const PATH_CHANGE_PASSWORD = "/change-password";
export const PATH_CREATE_PASSWORD = "/create-password";
export const PATH_FORGOT_PASSWORD = "/forgot-password";
export const PATH_OTP = "/otp";
export const PATH_LOGIN_BY_PHONE = "/request-by-phone";

export const PATH_REDEEM_CDIC_COUPON = "/redeem-cdic-coupon";
export const PATH_REDEEM_COUPON = "/redeem-coupon";
export const PATH_PATIENT = "/patient";
export const PATH_CDIC_PATIENT = "/cdic-patient";
export const PATH_TERMS_AND_CONDITIONS = "/terms-and-conditions";
export const PATH_PRIVACY_POLICY = "/privacy-policy";
export const PATH_MY_PROFILE = "/my-profile";
export const PATH_DEPO_RECORDS = "/depo-records";
export const PATH_CREATE_DEPO_RECORDS = "/create-records";
export const PATH_HEALTH_RECORDS = "/health-records";
export const PATH_HEALTH_RECORDS_CREATE = "/health-records/create";
export const PATH_SRHR_PATIENT = "/srhr-patient";
export const PATH_SALE_ORDER = "/sale-order";
export const PATH_CREATE_ORDER = "/create-order";
export const PATH_PRODUCT_MASTER = "/product-master";
export const PATH_PRODUCT_CREATE = "/product-create";
export const PATH_INVENTORY_MASTER = "/inventory-master";
export const PATH_INVENTORY_CREATE = "/inventory-create";
export const PATH_LOGISTIC = "/logistic";
export const PATH_REPORTS = "/reports";
export const PATH_CDIC_PROGRAM = "/cdic-program";
export const PATH_CREATE_CDIC_PROGRAM = "/create-cdic-program";
export const PATH_CREATE_SERVICE_NAME = "/create-service-name";
export const PATH_404 = "/*";

export const PATH_ABOUT = "/about";
export const PATH_BLOG = "/blog";
